import { GlobeIcon, ChevronDown } from "@components/atoms/Icons/index";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";

interface Props {
  classname: string;
  width: string;
  height: string;
  pclassname: string;
  rigth: boolean;
}

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function TranslationMenu({
  classname,
  height,
  pclassname,
  width,
  rigth=true,
}: Props) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className={classname}>
          <GlobeIcon width="20px" height="20px" />
          <p className={pclassname}>EN</p>
          <ChevronDown width={width} height={height} />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={classNames(
            rigth && "right-0",
            "absolute z-10 mt-2 w-56 origin-top-right bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          )}
        >
          <div className="">
            <Menu.Item>
              {({ active }) => (
                <a
                  href="/"
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "flex flex-row px-4 py-2 text-sm"
                  )}
                >
                  <p>English (EN)</p>
                  <img
                    src="//cdn.shopify.com/s/files/1/0044/3708/2200/t/80/assets/Site_Icons_Check.svg?v=131604951576796656651681246587"
                    className="ml-auto mr-3 check-icon"
                  />
                </a>
              )}
            </Menu.Item>
          </div>
          <div className="">
            <Menu.Item>
              {({ active }) => (
                <a
                  href="https://copic.jp"
                  target="__blank"
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "px-4 py-2 text-sm flex flex-row"
                  )}
                >
                  <p>日本語 (JP)</p>
                  <span className="text-[#6a74b7] text-[10px] flex flex-row">
                    <p>Visit Japan Site</p>{" "}
                    <img
                      src="//cdn.shopify.com/s/files/1/0044/3708/2200/t/80/assets/link-purple.svg?v=9164809954217975121681246419"
                      alt="link"
                    />
                  </span>
                </a>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
